import React, {useEffect, useState} from "react";
import {
    Table,
    Form,
    Input,
    Select,
    Button,
    Space,
    Card,
    Row,
    Col,
    Switch,
    message,
    Modal,
    Popconfirm,
    DatePicker
} from "antd";
import {SearchOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import styles from "./UserRechargePoints.module.css";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

import {Pagination} from 'antd';

import CommonModal from './Recharge/Common.js'

import {getRechargeListRequest} from "./api";
import {closeUserInfo, openLogin} from "../../../store/modalsSlice";
import settingIcon from "./setting.svg";
import {useDispatch, useSelector} from "react-redux";
import InfoItem from "./InfoItem";
import {setCurrentMenuKey} from "../HomePageSlice";
import {selectRechargeUserInfo} from "../teacherManager/teacherManagerSlice";
import dayjs from "dayjs";
const {Option} = Select;

const {RangePicker} = DatePicker;


const UserRechargePoints = () => {

    const dispatch = useDispatch();
    // 筛选表单状态
    const [filterForm, setFilterForm] = useState({
        name: "",
        status: ""
    });
    const [users, setUsers] = useState([]);
    // 分页状态

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [totalNumber, setTotalNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [status, setStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const [rangeTime,setRangeTime]=useState(['','']);

    const rechargeUserInfo = useSelector(selectRechargeUserInfo)


    const [user, setUser] = useState({
        name: "",
        email: ""
    });

    useEffect(() => {
        getRechargeList(status,rangeTime, (currentPage - 1)*limit, limit)
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

    function getRechargeList(status,rangeTime, offset, limit) {
        getRechargeListRequest(rechargeUserInfo.username, status, rangeTime, offset, limit, (data) => {
            if (data.ret === '1') {
                setUsers(data.data.data)
                setTotalNumber(data.data.total_num)
            } else {
                setUsers([])
                setTotalNumber(0)
            }
        });
    }


    function updateData() {
        setCurrentPage(1)
        setStatus('')
        setRangeTime(['',''])
        getRechargeList("",['',''], 0, limit)
    }


    // 处理筛选表单变化
    const handleFilterChange = (name, value) => {
        setFilterForm({
            ...filterForm,
            [name]: value
        });
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        console.log(current, pageSize);
        setCurrentPage(current)
        getRechargeList(status, rangeTime,(current - 1) * pageSize, pageSize)

    };


    const dateFormat = 'YYYY-MM-DD HH:mm';
    const today = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formatter = new Intl.DateTimeFormat('zh-CN', options);

    var maxDateString = formatter.format(today).replaceAll('/','-')+" 23:59";

    return (
        <div className={styles.background}>

            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>


                        <Button
                            icon={<LeftOutlined/>}
                            style={{marginRight: 20}}
                            onClick={(e) => {
                                dispatch(setCurrentMenuKey("6"))
                            }}
                        >
                            返回
                        </Button>
                        {/*积分分配*/}
                    </h3>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={(e)=>{
                            getRechargeList(status,rangeTime, (currentPage - 1)*limit, limit)
                        }}
                    >
                        刷新
                    </Button>
                </div>


                <Card title="" className={styles["card-top"]}>

                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={(e)=>{
                                setRangeTime(['',''])
                                setStatus('')
                            }}>
                                重置
                            </Button>
                            <Button
                                type="primary"
                                onClick={(e)=>{
                                    setCurrentPage(1)
                                    getRechargeList(status,rangeTime, 0, limit)
                                }}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={24} align="middle">
                        <Col span={4}
                        >
                            <Row align="middle">
                                <Col flex="70px"
                                >
                                    数据类型
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 70px)"}}
                                >
                                    <Select
                                        placeholder="请选择类型"
                                        value={status}
                                        onChange={(value) => {
                                            setStatus(value)
                                        }}
                                    >
                                        <Option value="">全部</Option>
                                        <Option value="1">增加</Option>
                                        <Option value="2">消耗</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col

                        >
                            <Row align="middle">
                                <Col flex="70px"
                                >
                                    操作时间
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 70px)"}}
                                >
                                    <RangePicker
                                        // locale={locale}
                                        // needConfirm = {true}
                                        // minDate={dayjs('2024-01-01', dateFormat)}
                                        minDate={dayjs('2024-01-01 00:00', dateFormat)}
                                        maxDate={dayjs(maxDateString, dateFormat)}
                                        showTime={{format: 'HH:mm'}}
                                        value={rangeTime[0].length > 0 ? [dayjs(rangeTime[0], dateFormat), dayjs(rangeTime[1], dateFormat)] : null}
                                        onChange={(date, dateString) => {
                                            setRangeTime(dateString)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                            <Space className={styles["bt-shaixuan2"]}>
                                {/*<Button*/}
                                {/*    style={{marginLeft: 'auto'}}*/}
                                {/*    type="primary"*/}
                                {/*    onClick={() => {*/}
                                {/*        setIsModalVisible(true)*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    导出*/}
                                {/*</Button>*/}
                                <Button
                                    style={{marginLeft: 'auto'}}
                                    onClick={() => {
                                        setIsModalVisible(true)
                                    }}
                                >
                                    分配
                                </Button>

                            </Space>

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >当前账号剩余积分
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作类型
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作积分数额
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >用途
                                    </td>
                                    {/* <td
                                        className={styles.td2}
                                    >会话id
                                    </td> */}
                                    <td
                                        className={styles.td2}
                                    >操作时间
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >备注
                                    </td>

                                </tr>
                                {users.map((item, index) => (
                                    <InfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <Pagination
                            hideOnSinglePage={false}//只有一页隐藏分页器
                            align="end"
                            style={{marginTop: 20}}
                            showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                            onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                            defaultCurrent={1}
                            current={currentPage}
                            total={totalNumber}
                            locale={{
                                items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                            }}
                            pageSizeOptions={['10', '20', '30']} // 自定义选项值
                            pageSize={limit}
                            onChange={onChangePage}
                            showLessItems={false} // 关闭"简化显示"模式
                        />
                    </div>
                </Card>
            </div>

            <CommonModal
                updateData={updateData}
                openStatus={isModalVisible}
                closeCommonModal={(e)=>{
                    setIsModalVisible(false)
                }}
            />


        </div>
    );
};

export default UserRechargePoints;

